<template>
  <div>
    <h5 class="feedback-question mb-4">
      {{ question_ }}
    </h5>
    <b-row align-v="center">
      <b-col
        v-for="(vote, index) in scale_vote"
        :key="index"
        class="icon-center"
      >
        <a
          v-b-tooltip
          href="#"
          :title="_(vote.label)"
          @click="sendVote(vote.value)"
          @mouseleave="vote.hover = false"
          @mouseover="vote.hover = true"
        >
          <i
            class="fa-2x icon-style text-primary"
            :class="classes(vote)"
          />
        </a>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'Feedback',
  props: {
    question: {
      type: String,
      default: '',
    },
    current_rating: {
      type: Number,
      default: null,
    },
    scale_vote: {
      default: () => [
        {
          label: 'Not really',
          value: -1,
          icon: 'fa-frown',
          hover: false,
        },
        {
          label: 'Kind of',
          value: 0,
          icon: 'fa-meh',
          hover: false,
        },
        {
          label: 'Yes',
          value: 1,
          icon: 'fa-smile',
          hover: false,
        },
      ],
    },
  },
  data: function () {
    return {
      question_: '',
    }
  },

  mounted() {
    if (this.question !== '' && this.question) {
      this.question_ = this.question
    } else {
      this.question_ = this._('Is this information helpful?')
    }
  },
  methods: {
    sendVote(vote) {
      const _this = this
      _this.$emit('sendVote', vote)
    },
    classes: function (vote) {
      const ret = []
      ret.push(vote.icon)
      if (vote.hover) {
        ret.push('far')
      } else {
        ret.push('fal')
      }
      if (this.current_rating !== null && parseInt(vote.value) === this.current_rating) {
        ret.push('text-secondary')
      }
      return ret
    },
  },
}
</script>

<style scoped>
.feedback-question {
  text-align: center;
  color: #0c5460;
}

.icon-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
